import { render, staticRenderFns } from "./orgs.vue?vue&type=template&id=ab510c38&"
import script from "./orgs.vue?vue&type=script&lang=js&"
export * from "./orgs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports